import { ApplicationConfig, provideBrowserGlobalErrorListeners, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker, SwUpdate } from '@angular/service-worker';
import { provideAnimations } from '@angular/platform-browser/animations';
import { filter } from 'rxjs';
import { environment } from '../environments/environment';


import { routes } from './app.routes';
import { jwtInterceptor } from './interceptors/jwt.interceptor';
import { noCacheInterceptor } from './interceptors/no-cache.interceptor';
import { offlineInterceptor } from './interceptors/offline.interceptor';
import { DbService } from './services/db.service';
import { AuthService } from './services/auth.service';
import { SyncService } from './services/sync.service';
import { LanguageService } from './services/language.service';

function initApp(db: DbService, auth: AuthService, sync: SyncService, lang: LanguageService, swUpdate: SwUpdate) {
  return async () => {
    await db.open();
    await auth.init();
    await lang.init();
    await sync.loadInitialCounts();
    sync.listenForReconnect();
    sync.listenForAppFocus();
    sync.sync().catch(() => { /* offline — syncs on reconnect */ });

    if (swUpdate.isEnabled) {
      swUpdate.versionUpdates.pipe(
        filter(e => e.type === 'VERSION_READY')
      ).subscribe(() => window.location.reload());

      // Check for updates every 30 minutes
      setInterval(() => swUpdate.checkForUpdate(), 30 * 60 * 1000);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([noCacheInterceptor, offlineInterceptor, jwtInterceptor])),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [DbService, AuthService, SyncService, LanguageService, SwUpdate],
      multi: true,
    },
  ],
};
